module.exports = __webpack_public_path__ + "static/media/calculadora-aluguel-anage.1c410de4.webp";